import { CollaborationServiceSetup, ContentPostDownloadDto, LearnerCertificateDownloadDto, MediaController, PostDownloadDto, QuizDownloadDto } from 'collaboration-service';
import { MediaType } from 'components/MediaSelection/FileSelector';
import MissingInput from 'components/MissingInput';
import { Httpsmailto, PPElink, UserLink } from 'Dummies/TestImpl/EditorBlots';
import { Button, Divider, Loader } from 'imaginarity-react-ui';
import * as _ from "lodash";
import * as React from 'react';
import { shallowCompare } from 'services/Helpers';
import { putToBlobStorageByteProgress } from 'services/Helpers/MediaHelpers';
import { ImgI18NTranslateFunction, useImgI18N } from 'services/ImgI18N';
import EditCategoryLike from '../Editors/EditCategoryLike';
import EditCategoryLikeMultiple from '../Editors/EditCategoryLikeMultiple';
import EditLanguageContents from '../Editors/EditLanguageContents';
import EditLanguageStrings from '../Editors/EditLanguageStrings';
import EditMedia from '../Editors/EditMedia';
import { EditorsSC as T } from '../Editors/EditorsSC';
import EditTwoDates from '../Editors/EditTwoDates';
import EditPartContainer, { EditPartContainerType, useEditPartContainer } from '../EditPartContainer';
import EditPartLabelAndEditor from '../EditPartLabelAndEditor';
import { BaseEditItem, GeneralPostEditorProps, useDispatchGPE, useSelectorGPE } from '../GeneralPostEdit';
import { GeneralPostEditActions, GeneralPostEditState, getValGPE, setValGPE, UploadList } from '../GeneralPostEditStateHandling';
import PostEditCertificate from './PostEditCertificate';
import PostEditQuiz from './PostEditQuiz';
import PostEditQuizCorrelatePairsQuestion from './PostEditQuizCorrelatePairsQuestion';
import PostEditQuizEstimateQuestion from './PostEditQuizEstimateQuestion';
import PostEditQuizFourPicturesOneSolutionQuestion from './PostEditQuizFourPicturesOneSolutionQuestion';
import PostEditQuizMarkAreaInPictureQuestion from './PostEditQuizMarkAreaInPictureQuestion';
import PostEditQuizMarkInPictureQuestion from './PostEditQuizMarkInPictureQuestion';
import PostEditQuizMultipleChoiceQuestion from './PostEditQuizMultipleChoiceQuestion';
import PostEditQuizSortQuestion from './PostEditQuizSortQuestion';

export const MissingTexts = {
    media: "media is missing.",
    headlines: "headline is missing.",
    descriptions: "description is missing.",
    categories: "category is missing.",
    location: "location is missing.",
    contentType: "content type is missing.",
    mediaType: "media type is missing.",
    content: "content is missing.",
    contentContent: "content for {{lng}} is missing.",
    contentLink: "link for {{lng}} is missing.",
    uploadRunning: "there are not finish uploads.",
    filesInUploadQueue: "there are files in your upload queue.",
    videosMissing: "videos are missing.",
    podcastsMissing: "podcast is missing.",
    set3Categories: "at least 3 categories are needed.",
};


type PD<T> = { [key: string]: T };

export const defMediaAspect: PD<number> = {
    "ContentPost": 16 / 9,
}
export const defMediaUploadType: PD<MediaType> = {
    "ContentPost": MediaType.IMAGE
}
export const defEditorFormats: PD<string[]> = {
    "ContentPost": ['bold', 'italic', 'underline', 'color', 'background', 'list', Httpsmailto, PPElink, UserLink, '@'],
    "StandardDescription": ['bold', 'italic', 'underline', 'color', 'background', 'list', '@'],
    "TubePost": ['bold', 'italic', 'underline'],   // will react on @    '#']
    "PodcastPost": ['bold', 'italic', 'underline'],   // will react on @    '#']
}

const defCalcMissing: PD<(post: PostDownloadDto, missing: string[], t: ImgI18NTranslateFunction) => void> = {
    "Post": (post, missing, t) => {
        if (post.media === undefined)
            missing.push(t(MissingTexts.media));
        if ((post.headlines ?? []).length === 0)
            missing.push(t(MissingTexts.headlines));
        if ((post.descriptions ?? []).length === 0)
            missing.push(t(MissingTexts.descriptions));
    },
    "ContentPost": (post, missing, t) => {
        defCalcMissing["Post"](post, missing, t);
        const ct = post as ContentPostDownloadDto;
        console.log('ct => ', ct);
        if ((ct.categories ?? []).length === 0)
            missing.push(t(MissingTexts.categories));
        if (ct.location?.id === undefined)
            missing.push(t(MissingTexts.location));
        if (ct.contentType?.id === undefined)
            missing.push(t(MissingTexts.contentType));
        if (ct.mediaType?.id === undefined)
            missing.push(t(MissingTexts.mediaType));
        if ((ct.content ?? []).length === 0)
            missing.push(t(MissingTexts.content));
        _.forEach(ct.content, c => {
            if (c.useContent && c.content === undefined)
                missing.push(t(MissingTexts.contentContent, { lng: c.lng }));
            if (!c.useContent && !c.link)
                missing.push(t(MissingTexts.contentLink, { lng: c.lng }));
        });
    }
}
export interface PostEditElementProps<T, S> {
    getter: (item: T) => S;
}

export const savePost = async <T extends BaseEditItem = BaseEditItem>(post: T, files: UploadList[], route?: string): Promise<T | undefined> => {
    const r = route ?? "api/post/"
    const type = post.type;
    let toSave: T | undefined = _.clone(post);
    for (let i = 0; i < files.length; i++) {
        const f = files[i];
        const val = getValGPE(toSave, f.nameStack);
        const sel = f.lng ? _.find(val, v => v.lng === f.lng) : undefined;
        const m: any = sel ? (f.selectMediaForLng ? getValGPE(sel, f.selectMediaForLng) : sel) : val;
        if (m.file) {
            const media = await putToBlobStorageByteProgress({ getUri: MediaController.GetUploadUriWithContainer, file: m.file });
            //console.log('media => ', media);
            if (media) {
                //console.log('sel => ', _.clone(sel));
                if (sel) {
                    //console.log('f.selectMediaForLng => ', f.selectMediaForLng);
                    if (f.selectMediaForLng) {
                        const res = setValGPE(sel, f.selectMediaForLng, media);
                        //console.log('res => ', res);
                        if (res.changed) {
                            const idx = _.findIndex(val, (v: any) => v.lng === f.lng)
                            val[idx] = res.data;
                        }
                    }
                    else {
                        const idx = _.findIndex(val, (v: any) => v.lng === f.lng)
                        //console.log('idx => ', idx);
                        val[idx] = media;
                        //console.log('val[idx] => ', val[idx]);
                    }
                }
                else {
                    //console.log('post before => ', toSave);
                    const res: any = setValGPE(toSave, f.nameStack, media);
                    if (res.changed)
                        toSave = res.data;
                }
            }
        }
        //console.log('post => ', toSave);
    }
    const client = CollaborationServiceSetup.client;
    if (toSave?.id) {
        // patch
        switch (type) {
            default: {
                const curP = toSave;
                const p = new Promise<T | undefined>((res, rej) => {
                    const fd = new FormData();
                    fd.append("data", JSON.stringify(curP));
                    client.call<T>({
                        onSuccess: res,
                        onError: () => res(undefined),
                        uri: `${r}${type}/${curP.id}`,
                        method: "PATCH",
                        data: fd,
                        headers: undefined,
                        type: undefined,
                    })
                });
                toSave = await p;
            }
                break;
        }
    }
    else {
        switch (type) {
            default: {
                const curP = toSave;
                const p = new Promise<T | undefined>((res, rej) => {
                    const fd = new FormData();
                    fd.append("data", JSON.stringify(curP));
                    client.call<T>({
                        onSuccess: res,
                        onError: () => res(undefined),
                        uri: `${r}${type}`,
                        method: "POST",
                        data: fd,
                        headers: undefined,
                        type: undefined,
                    })
                });
                toSave = await p;
            }
                break;

        }
    }
    return toSave;
}



const mapper = (s: GeneralPostEditState) => ({ post: s.post, files: s.files, originalPost: s.originalPost });

const PostEdit = (p: GeneralPostEditorProps<PostDownloadDto>) => {
    const { onSave, onCancel, onChangeNeedSave, onMount, onDismount, apiRoute } = p;
    const { post, files, originalPost } = useSelectorGPE(mapper, shallowCompare);
    const dispatch = useDispatchGPE();
    const [uploading, setUploading] = React.useState<boolean>(false);
    const type = post?.type ?? "";
    const { t } = useImgI18N("admin");
    const uEPC: EditPartContainerType = useEditPartContainer();
    //    console.log('files => ', files);
    const pp = post as PostDownloadDto;

    const saveInt = React.useMemo(() => () => {
        setUploading(true);
        const save = async () => {
            if (onSave) {
                const newPost = await savePost(pp, files, apiRoute);
                if (newPost)
                    onSave(newPost);
                dispatch(GeneralPostEditActions.batch([
                    GeneralPostEditActions.setOriginalPost(newPost),
                    GeneralPostEditActions.setPost(newPost),
                ]));
                setUploading(false);
                if (onChangeNeedSave)
                    onChangeNeedSave(false);
            }
        }
        save();
    }, [onSave, pp, files, dispatch, onChangeNeedSave, apiRoute]);

    const cancelInt = React.useMemo(() => () => {
        dispatch(GeneralPostEditActions.setPost(originalPost));
        if (onChangeNeedSave)
            onChangeNeedSave(false);
        if (onCancel)
            onCancel();
    }, [onCancel, dispatch, originalPost, onChangeNeedSave]);

    React.useEffect(() => {
        if (onMount)
            onMount(saveInt, cancelInt);
        return () => {
            if (onDismount)
                onDismount();
        }
    }, [onMount, onDismount, saveInt, cancelInt])

    const missing = React.useMemo(() => {
        const toRet: string[] = [];
        const check = (defCalcMissing[type] ?? defCalcMissing["Post"])!;
        if (pp)
            check(pp, toRet, t);
        return toRet;
    }, [pp, type, t]);

    const needSave = !(missing.length > 0 || _.isEqual(originalPost, post));
    React.useEffect(() => {
        if (onChangeNeedSave)
            onChangeNeedSave(needSave);
    }, [needSave, onChangeNeedSave])

    const { mediaAspect, mediaUploadType, editorFormats } = React.useMemo(() => ({
        mediaAspect: defMediaAspect[type],
        mediaUploadType: defMediaUploadType[type],
        editorFormats: defEditorFormats[type],
    }), [type]);

    const renderMore = React.useCallback((curUEPC: typeof uEPC, registerClosed: boolean) => {
        //console.log("PostEdit.tsx::256 => post", post);

        switch (type) {
            case "ContentPost":
                return (
                    <>
                        <EditPartContainer icon="cog" title="general properties" {...curUEPC}>
                            <EditPartLabelAndEditor>
                                {[
                                    { label: { icon: "clock", content: "published in between" }, editor: <EditTwoDates<PostDownloadDto> firstGetter={x => x.publicationDate} secondGetter={x => x.expirationDate} /> },
                                    { label: { icon: "tag", content: "categories" }, editor: <EditCategoryLikeMultiple<ContentPostDownloadDto> getter={x => x.categories} toSelect="categories" /> },
                                    { label: { icon: "location", content: "content location" }, editor: <EditCategoryLike<ContentPostDownloadDto> getter={x => x.location} toSelect="locations" /> },
                                    { label: { icon: "clipboard", content: "content type" }, editor: <EditCategoryLike<ContentPostDownloadDto> getter={x => x.contentType} toSelect="contentTypes" /> },
                                    { label: { icon: "file", content: "media type" }, editor: <EditCategoryLike<ContentPostDownloadDto> getter={x => x.mediaType} toSelect="mediaTypes" /> },

                                ]}
                            </EditPartLabelAndEditor>
                        </EditPartContainer>

                        <EditPartContainer icon="language" title="content" {...curUEPC}>
                            <EditLanguageContents<ContentPostDownloadDto> getter={x => x.content} />
                        </EditPartContainer>
                    </>
                )
            case "MultipleChoiceQuestion":
                return (<PostEditQuizMultipleChoiceQuestion
                    epc={curUEPC}
                    registerClosed={registerClosed}
                />);
            case "EstimateQuestion":
                return (<PostEditQuizEstimateQuestion
                    epc={curUEPC}
                    registerClosed={registerClosed}
                />);
            case "MarkInPictureQuestion":
                return (<PostEditQuizMarkInPictureQuestion
                    epc={curUEPC}
                    registerClosed={registerClosed}
                />);
            case "MarkAreaInPictureQuestion":
                return (<PostEditQuizMarkAreaInPictureQuestion
                    epc={curUEPC}
                    registerClosed={registerClosed}
                />);
            case "SortQuestion":
                return (<PostEditQuizSortQuestion
                    epc={curUEPC}
                    registerClosed={registerClosed}
                />);
            case "CorrelatePairsQuestion":
                return (<PostEditQuizCorrelatePairsQuestion
                    epc={curUEPC}
                    registerClosed={registerClosed}
                />);
            case "FourPicturesOneSolutionQuestion":
                return (<PostEditQuizFourPicturesOneSolutionQuestion
                    epc={curUEPC}
                    registerClosed={registerClosed}
                />);
            case "Quiz":
                return (<PostEditQuiz
                    epc={curUEPC}
                    post={post as QuizDownloadDto}
                    registerClosed={registerClosed}
                />);
            case "LearnerCertificate":
                return (
                    <PostEditCertificate
                        epc={curUEPC}
                        post={post as LearnerCertificateDownloadDto}
                        registerClosed={registerClosed}
                    />
                );
            default:
                return <>not implemented yet</>;
        }
    }, [type, post]);

    const registerClosed = false;    // temp, just during development
    //console.log('post => ', post);
    if (!post)
        return <Loader animation="loader_dna" active />;
    const isMultipleMedias = post.type === 'FourPicturesOneSolutionQuestion';
    return (
        <T.Container>
            <Loader
                active={uploading}
                animation="loader_dna"
            />
            <MissingInput title={t("missing input")} missing={missing} />

            <EditPartContainer icon="language" title="headlines" {...uEPC} registerClosed={registerClosed}>
                <EditLanguageStrings<PostDownloadDto> getter={x => x.headlines} editorFormats={editorFormats} />
            </EditPartContainer>

            <EditPartContainer icon="language" title="descriptions" {...uEPC} registerClosed={registerClosed}>
                <EditLanguageStrings<PostDownloadDto> getter={x => x.descriptions!} editorFormats={editorFormats} />
            </EditPartContainer>

            {!isMultipleMedias && <EditPartContainer icon="image effects" title="media" {...uEPC} registerClosed={registerClosed}>
                <EditMedia<PostDownloadDto> getter={x => x.media} imgAspect={mediaAspect} uploadType={mediaUploadType} width='50%' />
            </EditPartContainer>}
            {renderMore(uEPC, registerClosed)}
            {/* <CMSContentInfo /> */}
            <Divider color="@lightGrey" />
            <T.ContainerBottom>
                <Button
                    floated='left'
                    kind="cancelButton"
                    icon="times"
                    content={t("cancel")}
                    onClick={onCancel}
                />
                <Button
                    floated='right'
                    kind={!needSave ? "cancelButton" : "primary"}
                    bordered={!needSave}
                    icon="save"
                    disabled={!needSave}
                    content={t("save")}
                    onClick={saveInt}
                    tooltip={{
                        tooltipText: missing.length > 0 ? t("missing elements") : _.isEqual(originalPost, post) ? t("no changes have been detected") : t("save"),
                        position: "bottom-end"
                    }}
                />
            </T.ContainerBottom>
        </T.Container>

    );
}

// PostEdit.whyDidYouRender = {
//     logOnDifferentValues: true,
// }

export default PostEdit;
